import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var DEFAULT_SEARCH_FILTERS = {
  dateRange: [null, null],
  site: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  present_findings: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: {}
    },
    join: "or"
  },
  absent_findings: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: {}
    },
    join: "and"
  },
  lab_results: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  patient_type: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  dicom_upload: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  risk_groups: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  symptoms: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  report_status: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  modalities: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  questionnaire_response: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  report_edited_by: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  custom_tags: []
};
export var INITIAL_FILTERS_CONFIG = {
  custom_tags: [],
  dateRange: [null, null],
  site: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  present_findings: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: {}
    },
    join: "or"
  },
  absent_findings: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: {}
    },
    join: "and"
  },
  lab_results: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  patient_type: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  dicom_upload: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  risk_groups: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  symptoms: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  report_status: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  modalities: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  questionnaire_response: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  },
  report_edited_by: {
    tags: {
      dropdownTags: [],
      tags: [],
      dropdownMenuTags: []
    }
  }
};

/**
 * Complete empty state for filtersData — INITIAL_FILTERS_CONFIG plus all extra
 * fields that mergeMultipleSavedFilters can add (task_status, task_owner, etc.).
 * Use this when checking for manual additions after deselecting saved filters.
 */
export var EMPTY_STATE = _objectSpread(_objectSpread({}, INITIAL_FILTERS_CONFIG), {}, {
  program_type: [],
  ai_recommendation: [],
  manual_review: [],
  task_owner: [],
  task_status: [],
  taskDueDateRange: [null, null],
  task_labels: []
});